(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["halloween-sale-countdown"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (section) => {
      if (!section || section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';
      const end = new Date(section.dataset.endDate).getTime();
      const timer = section.querySelector('.halloween-sale__timer');
      const expired = section.querySelector('[data-expired]');
      const fields = {
        days: section.querySelector('[data-days]'),
        hours: section.querySelector('[data-hours]'),
        minutes: section.querySelector('[data-minutes]'),
        seconds: section.querySelector('[data-seconds]')
      };
      let interval;

      const update = () => {
        const distance = end - Date.now();
        if (!Number.isFinite(end) || distance <= 0) {
          timer.hidden = true;
          expired.hidden = false;
          clearInterval(interval);
          return false;
        }
        fields.days.textContent = String(Math.floor(distance / 86400000)).padStart(2, '0');
        fields.hours.textContent = String(Math.floor(distance / 3600000) % 24).padStart(2, '0');
        fields.minutes.textContent = String(Math.floor(distance / 60000) % 60).padStart(2, '0');
        fields.seconds.textContent = String(Math.floor(distance / 1000) % 60).padStart(2, '0');
        return true;
      };

      const codeButton = section.querySelector('[data-discount-code]');
      codeButton?.addEventListener('click', async () => {
        try {
          await navigator.clipboard.writeText(codeButton.dataset.discountCode);
          const label = codeButton.querySelector('[data-copy-label]');
          const original = label.textContent;
          label.textContent = codeButton.dataset.copiedLabel;
          window.setTimeout(() => { label.textContent = original; }, 1800);
        } catch (error) {
          codeButton.querySelector('strong')?.focus?.();
        }
      });

      if (update()) interval = window.setInterval(update, 1000);
    };

    document.querySelectorAll('[data-halloween-countdown]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('[data-halloween-countdown]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-attraction-banner"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-product-attraction-button]').forEach((button) => {
    button.addEventListener('click', () => {
      const productForm = document.querySelector('form[action*="/cart/add"]');
      if (!productForm) return;
      productForm.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
      const firstControl = productForm.querySelector('select, input:not([type="hidden"]), button');
      if (firstControl) window.setTimeout(() => firstControl.focus({ preventScroll: true }), 500);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (() => {
    const initializeDeadline = (banner) => {
      if (!banner || banner.dataset.initialized === 'true') return;
      banner.dataset.initialized = 'true';
      const endTime = new Date(banner.dataset.endDate).getTime();
      const timer = banner.querySelector('.product-order-deadline__timer');
      const fields = {
        days: banner.querySelector('[data-deadline-days]'),
        hours: banner.querySelector('[data-deadline-hours]'),
        minutes: banner.querySelector('[data-deadline-minutes]'),
        seconds: banner.querySelector('[data-deadline-seconds]')
      };
      let interval;

      const update = () => {
        const distance = endTime - Date.now();
        if (!Number.isFinite(endTime) || distance <= 0) {
          timer.textContent = banner.dataset.expiredText;
          timer.classList.add('product-order-deadline__timer--expired');
          clearInterval(interval);
          return false;
        }
        fields.days.textContent = String(Math.floor(distance / 86400000)).padStart(2, '0');
        fields.hours.textContent = String(Math.floor(distance / 3600000) % 24).padStart(2, '0');
        fields.minutes.textContent = String(Math.floor(distance / 60000) % 60).padStart(2, '0');
        fields.seconds.textContent = String(Math.floor(distance / 1000) % 60).padStart(2, '0');
        return true;
      };

      if (update()) interval = window.setInterval(update, 1000);
    };

    document.querySelectorAll('[data-order-deadline]').forEach(initializeDeadline);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-order-deadline]').forEach(initializeDeadline);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
